import { render, staticRenderFns } from "./TicketDetails.vue?vue&type=template&id=5820a0a5&scoped=true&"
import script from "./TicketDetails.vue?vue&type=script&lang=js&"
export * from "./TicketDetails.vue?vue&type=script&lang=js&"
import style0 from "./TicketDetails.vue?vue&type=style&index=0&id=5820a0a5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5820a0a5",
  null
  
)

export default component.exports